import React from 'react';
import Configurator from './Configurator.jsx';
import Button from "./ui/button/Button.jsx";
import Image from './ui/features/Image.jsx';
import styles from './HatchConfigurator.styl';
import Table from "./ui/features/Table.jsx";
import jQuery from "jquery";

import { euiDb, db } from './constants/hatch';


const assortment = euiDb.reduce((acc, item) => {
	(item.assortmentGroup || []).forEach(key => {
		if (acc[key]) acc[key].push(item);
	});
	return acc;
}, {1:[], 2:[], 3:[]});

class HatchConfigurator extends Configurator {

	//Конструктор
	constructor(props) {
		super(props);
		this.state = {
			//Списки
			itemList: [], 										// Подобранные аксессуары
			specList: [],                     // Спецификация оборудования
			sortSpecList:[],

			concrete:true,										// Выбран бетон
			floor:false,											// Выбран фальш-пол
			eui:false,

			filterEui:'Выбрать',
			euiOptions: ['Выбрать'],

			filterModulesEui:'Выбрать',
			modulesEuiOptions:['Выбрать'],

			filterScreed:'Выбрать',
			screedOptions:['Выбрать', '55', '57-75', '80-95', 'Выше 95'],

			filterModules:'Выбрать',
			modulesOptions:['Выбрать', '2', '6','8 (Onfloor)','12','16','24','6 классических ЭУИ','Без установки ЭУИ'],
			socetInfo:''
		}

		//Кнопки
		this.doPrint 														= this.doPrint.bind(this);
		this.onBtnExcelClick 										= this.onBtnExcelClick.bind(this);

		// Обработка событий таблиц
		this.onChangeQuantity 									= this.onChangeQuantity.bind(this);
		this.addBasket 													= this.addBasket.bind(this);
		this.onDelete 													= this.onDelete.bind(this);

		//Служебные процедуры функции

		this.onConcreteCheckChange							= this.onConcreteCheckChange.bind(this);
		this.onFloorCheckChange									= this.onFloorCheckChange.bind(this);
		this.onEuiCheckChange                   = this.onEuiCheckChange.bind(this);

		this.onEuiChange                        = this.onEuiChange.bind(this);
		this.onModulesEuiChange                 = this.onModulesEuiChange.bind(this);
		this.onScreedChange											= this.onScreedChange.bind(this);
		this.onModulesChange										= this.onModulesChange.bind(this);

		this.changeHandlerEui                   = this.changeHandlerEui.bind(this);
		this.changeHandler											= this.changeHandler.bind(this);
		this.openKNS														= this.openKNS.bind(this);
		this.calcTotalPrice                     = this.calcTotalPrice.bind(this);
		this.generateNameSolution               = this.generateNameSolution.bind(this);
		this.sortingSpecList                    = this.sortingSpecList.bind(this);
		this.generateEuiList                    = this.generateEuiList.bind(this)
		this.generateEuiAssortmentList	   		= this.generateEuiAssortmentList.bind(this);
		this.generateKeySolution                = this.generateKeySolution.bind(this)

	}


	// ++ Для Запуска

	getCustomStyles() {
		return styles;
	}

	getType() {
		return 'hatch';
	}
	// -- Для Запуска

	// ++ Работа таблиц

	//Отображение выбранного значения
	onListItemCheck(item) {
		if (this.state.item && (item.article === this.state.item.article)) {
			return;
		}

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				this.setState({item: items});
			}
		);
	}

	// Добавить элемент в корзину
	addBasket(item) {
		if (this.state.item && (item.article === this.state.item.article)) {
			return;
		}
		let elem=Object.assign({}, item)
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				this.setState((prevState)=> {
					const specList = [...prevState.specList]
					if (specList.some(i =>i.marker===elem.marker && i.article === elem.article)) {
						specList.map(i => {
							if(i.article === elem.article && i.marker===elem.marker) {
								i.mark=this.generateNameSolution(i.marker)
								i.price = items[0].price
								i.count += 1 * item.amount
								i.sum = Math.round( 100*i.count*i.price)/100
							}
							return i

						})
					} else {
						elem.mark=this.generateNameSolution(elem.marker)
						elem.price = items[0].price
						elem.count = 1 * elem.amount
						elem.sum = Math.round( 100*elem.count*elem.price)/100
						specList.push(elem)
					}
					return {specList}
				},()=>{
					this.doAddToCart(this.state.specList)
				});
				this.sortingSpecList()
	}
		);

	}

	//Удаление
	onDelete(item) {

		this.setState((prevState) => {

			return {
				...prevState,
				specList: prevState.specList.filter((el) => el.article !== item.article || el.marker!==item.marker),

			}
		},()=>{
			this.doAddToCart(this.state.specList)
		})
		this.sortingSpecList()
	}

	// изменение количества позиции
	onChangeQuantity(item, value) {

		this.setState(prevState => {
			const newBasket = prevState.specList.map(i => {
				if (i.article === item.article && i.marker===item.marker) {
					i.count = +value
					i.sum = i.price*i.count
				}
				return i
			})
			return {
				specList: newBasket
			}
		},()=>{
			this.doAddToCart(this.state.specList)
		})
	}
	// сортировка корзины по решениям
  sortingSpecList(){

	 this.setState((prevState)=>{
		 return{sortSpecList: Object.entries(prevState.specList.reduce((obj,item)=> {if(obj[item.marker]){
					 obj[item.marker].push(item)
				 } else {
					 obj[item.marker]=[item]
				 }
					 return obj}, {}
			 ))}
	 }

	 )
 }

// -- Работа таблиц

	// ++ Служебные процедуры и функции
	calcTotalPrice(){
		return 	this.state.specList.reduce((sum,item)=>Math.round(100*(item.price*item.count+sum))/100,0)
	}
	// -- Служебные процедуры и функции


	// ++ Обработка событий

	// ++ Дропдауны

	onScreedChange(event){

		let value = event.target.value
		let modulesOptions = []
		if(this.state.concrete){
			switch (value){
				case 'Выбрать':break;
				case '55': modulesOptions = ['Выбрать', '3']; break;
				case '57-75': modulesOptions = ['Выбрать', '2', '6','12']; break;
				case '80-95': modulesOptions = ['Выбрать', '6','8 (Onfloor)','16','24','6 классических ЭУИ','Без установки ЭУИ']; break;
				case 'Выше 95': modulesOptions = ['Выбрать','8 (Onfloor)','8 (Primer)','12','16','24','6 классических ЭУИ','Без установки ЭУИ']; break;
			}
		}
		this.setState({
			modulesOptions,
			eui: false
		},()=>{
			this.changeHandler(value, this.state.filterModules)
		})

	}

	onModulesChange(event){

		let value = event.target.value
		this.changeHandler(this.state.filterScreed, value)

	}

	changeHandler(screed, modules){
		let itemList = []
		let socetInfo = ''
		let cop = this.state.concrete



		if(cop){
			switch(screed){
				case 'Выбрать':break
				case '55':
					switch(modules){
						case 'Выбрать':break
						case '3':itemList.push({...db[14], amount:1, marker: this.generateKeySolution(screed, modules, cop)});break
					}break;
				case '57-75':
					switch(modules){
						case 'Выбрать':break
						case '2':itemList.push({...db[13], amount:1, marker: this.generateKeySolution(screed, modules, cop)});break
						case '6':itemList.push({...db[7], amount:1, marker: this.generateKeySolution(screed, modules, cop)});break
						case '12':itemList.push({...db[9], amount:1,marker: this.generateKeySolution(screed, modules, cop)},{...db[1], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
					}break;
				case '80-95':
					switch(modules){
						case 'Выбрать':break
						case '6':itemList.push({...db[7], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
						case '8 (Onfloor)':itemList.push({...db[10], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[6], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[3], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[4], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
						case '16':itemList.push({...db[10], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)},{...db[3], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[6], amount:2,marker: this.generateKeySolution(screed, modules, cop)});break
						case '24':itemList.push({...db[10], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[12], amount:2,marker: this.generateKeySolution(screed, modules, cop)});break
						case '6 классических ЭУИ':itemList.push({...db[10], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[5], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[3], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
						case 'Без установки ЭУИ':itemList.push({...db[11], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
					} break;
				case 'Выше 95':
					switch(modules){
						case 'Выбрать':break
						case '8 (Onfloor)':itemList.push({...db[10], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[6], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[3], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[4], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)},{...db[0], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
						case '8 (Primer)':itemList.push({...db[15], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[16], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
						case '12':itemList.push({...db[10], amount:1,marker: this.generateKeySolution(screed, modules, cop)},{...db[1], amount:1,marker: this.generateKeySolution(screed, modules, cop)},{...db[0], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
						case '16':itemList.push({...db[10], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)},{...db[3], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[6], amount:2,marker: this.generateKeySolution(screed, modules, cop)},{...db[0], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
						case '24':itemList.push({...db[10], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[12], amount:2,marker: this.generateKeySolution(screed, modules, cop)},{...db[0], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
						case '6 классических ЭУИ':itemList.push({...db[10], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[5], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[3], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)},{...db[0], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
						case 'Без установки ЭУИ':itemList.push({...db[11], amount:1,marker: this.generateKeySolution(screed, modules, cop)},{...db[0], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
					} break;
			}

		}else{
			switch(modules){
				case 'Выбрать':break
				case '3':itemList.push({...db[14], amount:1, marker: this.generateKeySolution(screed, modules, cop)});break
				case '6':itemList.push({...db[8], amount:1, marker: this.generateKeySolution(screed, modules, cop)});break
				case '8 (Onfloor)':itemList.push({...db[3], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[6], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[4], amount:1,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
				case '8 (Primer)':itemList.push({...db[15], amount:1, marker: this.generateKeySolution(screed, modules, cop)});break
				case '12':itemList.push({...db[1], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
				case '16':itemList.push({...db[3], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[6], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
				case '24':itemList.push({...db[12], amount:2,marker: this.generateKeySolution(screed, modules, cop)}, {...db[2], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
				case 'Без установки ЭУИ':itemList.push({...db[11], amount:1,marker: this.generateKeySolution(screed, modules, cop)});break
			}
		}

		if(modules === '8 (Primer)' || modules === '8 (Onfloor)'){
			socetInfo = '* 4 розетки 45х45'
		} else if(modules && modules !== 'Выбрать' && modules !== 'Без установки ЭУИ' && modules !== '6 классических ЭУИ' && modules !== '2' && modules !== '3'){
			socetInfo ='*'+ modules/2 + ((modules/2)<5? ' розетки 45х45': ' розеток 45х45')
		}

		this.setState({
			eui:false,
			itemList,
			filterEui: 'Выбрать',
			filterModulesEui: 'Выбрать',
			filterModules: modules,
			filterScreed: screed,
			socetInfo
		})

	}

	onEuiChange(event){
		const value = event.target.value
		const modulesEuiOptions = value === 'Выбрать'
			? ['Выбрать']
			: ['Выбрать', ...new Set(euiDb.filter(i => i.group === value).map(i => i.modulesNumber))]
		this.changeHandlerEui(value, 'Выбрать', this.state.filterScreed, this.state.filterModules);

		this.setState({
			filterEui: value,
			filterModulesEui: 'Выбрать',
			modulesEuiOptions
		})
	}

	onModulesEuiChange(event){
		const value = event.target.value
		this.changeHandlerEui(this.state.filterEui, value, this.state.filterScreed, this.state.filterModules)
	}

	changeHandlerEui(eui, modulesEui, screed, modules) {
		let euiList = this.generateEuiAssortmentList();
		let cop = this.state.concrete

		if(eui !== 'Выбрать'){
			euiList = euiList.filter((item) => item.group === eui)
			if(modulesEui !== 'Выбрать'){
				euiList = euiList.filter((item) => item.modulesNumber === modulesEui)
			}
		} 
		euiList = euiList.map((item) => ({...item, amount: 1, marker: this.generateKeySolution(screed, modules, cop)}))
		const itemList = this.state.itemList.filter(i=>i.showTable).concat(euiList)

			this.setState({
				itemList,
				filterModulesEui: modulesEui,
				filterEui:eui
			})

		}

	// -- Дропдауны

	generateKeySolution(screed, modules, cop) {
		if (modules === '8 (Primer)') {
			if (cop) {
				const screedPart = isNaN(screed[0]) ? screed[5] + screed[6] : screed.substring(0, 5)
				return 'solutionConcrete_' + screedPart + '_8metal'
			}
			return 'solutionFloor_8metal'
		}
		let mark
		if (cop) {
			(isNaN(screed[0])) ? (isNaN(modules[0])) ? mark = 'solutionConcrete' + '_' + screed[5] + screed[6] + '_' + '1' :
					(isNaN(modules[1])) ? mark = 'solutionConcrete' + '_' + screed[5] + screed[6] + '_' + modules[0] : mark = 'solutionConcrete' + '_' + screed[5] + screed[6] + '_' + modules[0] + modules[1] :
				(isNaN(modules[0])) ? mark = 'solutionConcrete' + '_' + screed.substring(0, 5) + '_' + '1' : (isNaN(modules[1])) ? mark = 'solutionConcrete' + '_' + screed.substring(0, 5) + '_' + modules[0] :
					mark = 'solutionConcrete' + '_' + screed.substring(0, 5) + '_' + modules[0] + modules[1]
			return mark
		} else {
			(isNaN(modules[0])) ? mark = 'solutionFloor' + '_' + '1' : mark = 'solutionFloor' + '_' + modules
			return mark
		}
	}
	generateNameSolution(key){
		const data=key.split('_')
		if(data[0]==='solutionFloor'){
			if(data[1]==='8metal'){
				return 'Для фальш-пола на 8 модулей (металл)'
			}else
			if(data[1]==='24'){
				return 'Для фальш-пола на '+ data[1] +' модуля '
			}else
			if(data[1]==='1'){
				return "Для фальш-пола без установки ЭУИ"
			}else {
				return 'Для фальш-пола на '+ data[1] +' модулей '
			}
		}else{
			if(data[2]==='8metal'){
				return 'Для бетона '+ data[1] +' на 8 модулей (металл)'
			}else
			if(data[2]==='2'){
				return 'Для бетона '+ data[1] +' на 2 модуля'
			}else
			if(data[2]==='3'){
				return 'Для бетона '+ data[1] +' на 3 модуля'
			}else
			if(data[2]==='24'){
				return 'Для бетона '+ data[1] +' на '+ data[2] +' модуля '
			}else
			if(data[2]==='1'){
				return "Для бетона "+ data[1] +" без установки ЭУИ"
			}else
			if(data[2]==='3 '){
				return "Для бетона "+ data[1] +" на "+ data[2] +"ЭУИ"
			}else {
				return 'Для бетона '+ data[1] +' на '+ data[2] +' модулей '
			}
		}

	}

	generateEuiList(){
		let itemList= this.state.itemList.filter(i=> i.showTable)
		const mark=this.generateKeySolution(this.state.filterScreed,this.state.filterModules,this.state.concrete)
			if (!this.state.eui) {
				const euiList = this.generateEuiAssortmentList();
				euiList.map(i=> {i.marker=mark, i.amount=1})
				return itemList.concat(euiList)
			} else {
				return itemList
			}
	}

	generateEuiAssortmentList(){
		let itemList= this.state.itemList.filter(i=> i.showTable)
		const hatch = itemList.find(i => i.assortment != null)
		const euiList = (hatch ? (assortment[hatch.assortment] || euiDb) : euiDb).slice()
		return euiList;
	}

	// ++ Чекбокс
	onConcreteCheckChange(){
		const modulesOptions = ['Выбрать', '2', '6','8 (Onfloor)','12','16','24','6 классических ЭУИ','Без установки ЭУИ']
		this.setState({
			socetInfo: '',
			filterModules: 'Выбрать',
      eui: false,
			concrete: true,
			floor: false,
			itemList:[],
			modulesOptions
		})

	}

	onFloorCheckChange(){
		const modulesOptions = ['Выбрать', '3', '6','8 (Onfloor)','8 (Primer)','12','16','24','Без установки ЭУИ']
		this.setState({
			filterModules: 'Выбрать',
			itemList:[],
			concrete: false,
			eui: false,
			floor: true,
			filterScreed: 'Выбрать',
			modulesOptions,
			socetInfo: ''
		})
	}

	onEuiCheckChange(){
		const itemList = this.generateEuiList();
		const euiAssortmentList = this.generateEuiAssortmentList();
		const euiOptions = ['Выбрать', ...new Set(euiAssortmentList.map(i => i.group).filter(Boolean))];
		this.setState(()=>{
			const eui=!this.state.eui
			return {
				eui,
				euiOptions,
				filterEui: 'Выбрать',
				filterModulesEui: 'Выбрать',
     			itemList
			}
		})
	}
	// -- Чекбокс
	// -- Обработка событий

	// ++Кнопки
	getCustomButtons() {
		let elements = [];

		elements.push(
			<Button
				x="532"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Открыть конфигуратор КНС"
				onClick={this.openKNS}
				key="knsopen"
			/>
		);

		elements.push(
			<Button
				x="940"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="736"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="1144"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={this.onBtnExcelClick}
				key="excel"
			/>
		);



		return elements;
	}
	//-- Кнопки

	openKNS(){
		window.open('https://www.iek.ru/products/configurators/kns/', '_blank');
	}

	// ++ Обработка печати
	doPrint(params) {
		let _params = params || {};

		_params.data = {
			specList: JSON.stringify(this.state.sortSpecList)
		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}
// -- Обработка печати



	render() {
		return (
			<div className={styles.cfg}>
				{/*Белый фон и лого*/}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '11%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Желтый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#ffc93a', width: '100%', height: '80px'}}/>
				<div className={styles.title}>Подбор аксессуаров к лючкам напольным IEK</div>

				{/*Левая часть*/}
				<CustomeCheckBox type='floor' x={145} lableX={40} y={117} lableY={120} header='Фальш-пол:' key='mainchbox2'
												 app={this}/>
				<CustomeCheckBox type='concrete' x={300} lableX={240} y={117} lableY={120} header='Бетон:' key='mainchbox1'
												 app={this}/>

				<DropDown
					type='modules'
					x={40}
					y={145}
					header='Количество модулей, шт:'
					disabled={this.state.concrete && this.state.filterScreed === 'Выбрать'}
					key='modules'
					app={this}
				/>

				<span className={styles.showAdditionLength}>
						{this.state.socetInfo}
					</span>

				{this.state.concrete &&
					<DropDown
						type='screed'
						x={240}
						y={145}
						header='Высота стяжки, мм:'
						disabled={!(this.state.screedOptions.length > 1)}
						key='screed'
						app={this}/>
				}
				{this.state.filterScreed && this.state.filterScreed === 'Выше 95' &&
					<div style={{
						position: 'absolute',
						top: '199px',
						left: '40px',
						width: '405px',
						color:'red',
						zIndex:'10'
					}}>Не забудьте добавить нивелирующий комплект, для увеличения высоты посадки до 35 мм. Комплект состоит из 4 нивелирующих ножек.</div>
				}

				<CustomeCheckBox type='eui' x={80} lableX={40} y={225} lableY={227} header='Эуи:' key='mainchbox3'
												 app={this}/>
				{!this.state.eui &&
					<div>
						<div style={{position: 'absolute', backgroundColor: '#ffffff', left:'20px', width: '440px', height: '155px', top: '100px', zIndex:'1'}}/>

						<div className={styles.picSectionTitle} style={{top: '265px'}}><span>Ваше решение</span></div>
						<div style={{position: 'absolute', backgroundColor: '#ffffff', left:'20px', width: '440px', height: '235px', top: '290px', zIndex:'1'}}>
							<div className={styles.solution}>
								{
									this.state.itemList.length > 0
										?
										this.state.itemList.map((item) =>{
											if (item.showTable){
											if (item.amount === 1){
												return <div key={item.article} className={styles[item.article]}  onClick={()=>this.onListItemCheck(item)} />
											}else if(item.amount === 2){

												return (<div>
													<div key={item.article+1} style={{marginRight:'10px'}} className={styles[item.article]} onClick={()=>this.onListItemCheck(item)} />
													<div key={item.article+2} className={styles[item.article]} onClick={()=>this.onListItemCheck(item)} />
												</div>)
											}
											return null
										}})
										:
										null
								}
							</div>
						</div>


						{/*Спецификация*/}
						<Table
							title='Аксессуары'
							type='NoBucket'
							items={this.state.itemList}
							styles={{
								width: '440px',
								height: '210px',
								top: '540px',
								left: '20px',
								fontSize: '12px'
							}}
							onSelect={this.onListItemCheck}
							addBasket={this.addBasket}
							itemInfo={this.state.item}
						/>
					</div>
				}



				{this.state.eui &&
					<div>
					<DropDown
						type='eui'
						x={40}
						y={250}
						header='Группа ЭУИ:'
						disabled={!this.state.eui}
						key='eui'
						app={this}
					/>

					<DropDown
					type='modulesEui'
					x={240}
					y={250}
					header='Количество модулей, шт:'
					disabled={!this.state.eui && this.state.filterEui === 'Выбрать'}
					key='modulesEui'
					app={this}
					/>

					<div style={{position: 'absolute', backgroundColor: '#ffffff', left:'20px', width: '440px', height: '205px', top: '100px', zIndex:'1'}}/>

					<div className={styles.picSectionTitle} style={{top: '315px'}}><span>Ваше решение</span></div>
					<div style={{position: 'absolute', backgroundColor: '#ffffff', left:'20px', width: '440px', height: '235px', top: '340px', zIndex:'1'}}>
					<div className={styles.solution}>
				{
					this.state.itemList.length > 0
					?
					this.state.itemList.map((item) =>{
						if (item.showTable){
					if (item.amount === 1){
					return <div key={item.article} className={styles[item.article]}  onClick={()=>this.onListItemCheck(item)} />
				}else if(item.amount === 2){

					return (<div>
					<div key={item.article+1} style={{marginRight:'10px'}} className={styles[item.article]} onClick={()=>this.onListItemCheck(item)} />
					<div key={item.article+2} className={styles[item.article]} onClick={()=>this.onListItemCheck(item)} />
					</div>)
				}
					return null
				}})
					:
					null
				}
					</div>
					</div>


				{/*Спецификация*/}
					<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.state.itemList}
					styles={{
					width: '440px',
					height: '165px',
					top: '590px',
					left: '20px',
					fontSize: '12px'
				}}
					onSelect={this.onListItemCheck}
					addBasket={this.addBasket}
					itemInfo={this.state.item}
					/>
					</div>
				}

				{/*Середина*/}
				{/*Корзина*/}
				{
					<Table
						title='Корзина по решениям'
						type='Bucket'
						items={this.state.sortSpecList}
						styles={{width: '440px', height: '552px', top: '100px', left: '480px', fontSize: '12px'}}
						onSelect={this.onListItemCheck}
						onDelete={this.onDelete}
						onChangeQuantity={this.onChangeQuantity}
						totalPrice={this.calcTotalPrice()}
						nameSolution={this.generateNameSolution}
						configType='hatchSep'
					/>}

				{/*Правая часть*/}
				{/* Артикул и имя */}
				<div className={styles.itemInfoBG}/>
				{this.state.item && this.state.item[0] ? (
					<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.item[0].art}`}
						 target="_blank">
						<div className={styles.itemInfo}>
							<div className={styles.itemInfo_Article}>{this.state.item[0].art}</div>
							<div>{this.state.item[0].name}</div>
						</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg}
					url={this.state.item && this.state.item[0] && this.state.item[0].ImgPng[0].file_ref.uri ? this.state.item[0].ImgPng[0].file_ref.uri : null}
				/>

				{/* Описание */}
				<div style={{
					position: 'absolute',
					top: '452px',
					left: '940px',
					backgroundColor: '#fff',
					width: '434px',
					height: '292px'
				}}/>
				{this.state.item && this.state.item[0] && this.state.item[0].Description[0].desc_ru ? (
					<div className={styles.description}>
						{this.state.item[0].Description[0].desc_ru}
					</div>
				) : (
					<div className={styles.descriptionEmpty}>
					</div>
				)}


				{/*Кнопки*/}
				{this.getCustomButtons ? this.getCustomButtons() : null}

				{/*Нижняя плашка*/}
				{/* На основной сайт IEK */}
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '820px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '20px',
					top: '820px',
					left: '700px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '823px',
					left: '415px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>
		)
	}
}

export default HatchConfigurator;


class DropDown extends React.Component {

	render() {

		let typeCap = this.props.app.capitalizeFirstLetter(this.props.type)

		return <div>
			<span className={styles.selectLabel} style={{top: this.props.y + 'px', left: this.props.x + 'px'}}>{this.props.header}</span>
			<select
				className={styles.selectBase}
				style={{top: this.props.y + 17 + 'px', left: this.props.x + 'px'}}
				onChange={this.props.app['on' + typeCap + 'Change']}
				value={this.props.app.state['filter' + typeCap]}
				// disabled={!(this.props.app.state[this.props.type + 'Options'].length > 1)}
				disabled={this.props.disabled}
			> {this.props.app.state[this.props.type + 'Options'].length > 0
				? this.props.app.state[this.props.type + 'Options'].map((option, index) => {
					return (
						<option value={option} key={index + option}>{option} </option>)
				})
				: <option value="Выбрать">Выбрать</option>
			}
			</select>
		</div>
	}

}

class CustomeCheckBox extends React.Component {

	render() {

		let typeCap = this.props.app.capitalizeFirstLetter(this.props.type)

		return <div>
			<label className={styles.sectionTitle}
						 style={{top: this.props.lableY + 'px', left: this.props.lableX+ 'px', zIndex:'10'}}>{this.props.header}</label>
			<input
				style={{top: this.props.y + 'px', left: this.props.x + 'px', position: 'absolute', zIndex: '10'}}
				type="checkbox"
				disabled={this.props.app.state.filterModules === 'Выбрать'&&this.props.type==='eui'}
				checked={this.props.app.state[this.props.type]}
				onChange={this.props.app['on' + typeCap + 'Check'+'Change']}/>
		</ div>
	}
}



// WEBPACK FOOTER //
// ./src/react/HatchConfigurator.jsx